module.exports = __webpack_public_path__ + "img/bannerBg.5853dda2.png";